import React from 'react'
const ThemeContext = React.createContext({isDarkMode:true});
export default ThemeContext;